import request from '@/utils/request'
import host from '@/api/base/host'

const mini = host.path('dev', { dev: 'v1' })
// 获取小程序配置信息
export const getMiniParam = (data) => {
  return request({ url: mini('common/getMini'), method: 'post', data })
}
